import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { messages } from "../views/Job/Job.messages";
import ToggleChatButton from "./ToggleChatButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { useState } from "react";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import MessageCenterModal from "./MessageCenterModal";
import { useNavigate } from "react-router-dom";
import useUserAccount from "../hooks/useUserAccount";

const JobSupport = (props) => {
    const navigate = useNavigate();
    const [showMessageCenterModal, setShowMessageCenterModal] = useState(false);
    const { userName } = useUserAccount();
    const lng = props.intl.formatMessage;

    const toggleMessageCenterModal = () => {
        setShowMessageCenterModal(!showMessageCenterModal);
    }

    /**
     * Show a success message on the invoice page once a message has been sent.
     */
    const handleMessageSent = () => {
        const alert = { message: lng(messages.messageIsSent), type: 'success' };
        navigate("/messagecenter", { state: { fromJob: true, alert } });
    }

    const tooltipContent = () => {
        if (!props.messageCenterAuthorized){
            return (
                <Tooltip id='maintenance-ongoing'>
                    {lng(messages.loginToSendMessage)}
                </Tooltip>
            );
        } else if (props.maintenance) {
            return (
                <Tooltip id='maintenance-ongoing'>
                    { lng(messages.underMaintenance) }
                </Tooltip>
            );
        } else if (!props.showNewMessageButton) {
            return (
                <Tooltip id='maintenance-ongoing'>
                    { lng(messages.ongoingMessaging) }
                </Tooltip>
            );
        } else {
            return null;
        }
    }

    const tooltip = tooltipContent();

    return (
        <Card className='fullwidth-mobile grey-bottom-border-mobile'>
            <Card.Body>
                <h3 id="get-support-title">{lng(messages.getSupport)}</h3>
                <ul className='list-unstyled job-actions'>
                    {props.showChatButton && props.livechatParameters !== null && (
                        <li>
                            <span className='label'>
                                <ToggleChatButton
                                    visitor={{ name: userName(), email: '' }}
                                    parameters={props.livechatParameters}
                                />
                            </span>
                        </li>
                    )}
                    {props.showMessageCenterButton && (
                        <li>
                            <span className='label '>
                                <OverlayTrigger
                                    key='show-maintenance-ongoing'
                                    trigger={['hover', 'click']}
                                    rootClose={true}
                                    placement='top'
                                    overlay={tooltip}
                                    show={tooltip ? undefined : false}
                                >
                                    <Button
                                        className={props.maintenance || !props.showNewMessageButton || !props.messageCenterAuthorized ? 'show-mandate listbutton-disabled actionlist-button' : ' show-mandate actionlist-button'}
                                        variant='tertiary'
                                        onClick={() => {
                                            if (!props.maintenance && props.showNewMessageButton) {
                                                toggleMessageCenterModal();
                                            }
                                        }}
                                        aria-label={lng(messages.createNewMessage)}
                                    >
                                        <FontAwesomeIcon icon={far.faEnvelopeOpenText} aria-hidden="true" />
                                        {lng(messages.createNewMessage)}
                                        <span className='float-end' aria-hidden="true">
                                            <FontAwesomeIcon icon={far.faChevronRight} />
                                        </span>
                                    </Button>
                                </OverlayTrigger>
                            </span>
                        </li>
                    )}
                </ul>
                {props.messageCenterAuthorized && (
                    <MessageCenterModal
                        show={showMessageCenterModal}
                        onClose={toggleMessageCenterModal}
                        onSuccess={handleMessageSent}
                        job={props.job}
                    />
                )}
            </Card.Body>
        </Card>
    )
}

JobSupport.propTypes = {
    intl: PropTypes.object.isRequired,
    showChatButton: PropTypes.bool,
    showMessageCenterButton: PropTypes.bool,
    showNewMessageButton: PropTypes.bool,
    livechatParameters: PropTypes.array,
    maintenance: PropTypes.bool,
    messageCenterAuthorized: PropTypes.bool,
    job: PropTypes.object
}

export default injectIntl(JobSupport);